$.module('request', function () {
  /**
   * 请求基础方法
   * @param       {Object} options 支持jQuery所有默认参数
   * {
   *    url : String url地址
   *    urlType : String url类型，默认为api
   *    type : String 发送请求类型
   *    requireToken : Boolean 是否需要添加token，非必须，如果url中包含access_token会自动添加
   *    disableCommonErrorHandler : Boolean 是否不需要默认的错误处理
   *    isKeepData : Boolean 是否保留GET请求中的data数据
   *    success : Function 请求正确回调
   *    error : Function 请求错误回调
   * }
   * @constructor
   * @return      {[type]}         [description]
   */
  function _request(options) {
    if (!options.url) {
      MM.core.debug('url is required : ', options);

      return;
    }

    options = _.assign(
      {
        type: 'GET',
        urlType: 'api',
        cache: false,
        dataType: 'json',
        isKeepData: false,
        data: {},
        contentType: '',
      },
      options,
    );

    options.data = options.data || {};

    //如果需要token则在参数中带上access_token
    if (options.requireToken || /\{access_token\}/.test(options.url)) {
      if (!MM.user.isLogin()) {
        MM.user.popupLogin();

        return;
      } else {
        // console.log('options.url===>',options.url)
        options.data.access_token = MM.user.getToken();
      }
    }

    options.url = MM.core.getRoot(options.url, options.urlType);
    options.url = $.formatByVal(options.url, options.data, true);
    options.type = options.type.toUpperCase();

    // 如果是登录用户 url 没有带token的 自动加上token参数
    if (!/access_token|\w{32}/.test(options.url) && MM.user.isLogin()) {
      options.url +=
        (options.url.indexOf('?') > -1 ? '&' : '?') +
        'access_token=' +
        MM.user.getToken();
    }

    if (options.contentType.toUpperCase() === 'FORM_URL') {
      options.contentType = 'application/x-www-form-urlencoded';
    } else {
      // 非api接口的post请求使用json数据格式
      if (
        (options.type === 'POST' &&
          !/(api|amber)\.memeyule\.com/.test(options.url)) ||
        options.contentType.toUpperCase() === 'JSON'
      ) {
        _.assign(options, {
          contentType: 'application/json;charset=utf-8',
        });

        if (!_.isEmpty(options.data)) {
          options.data = JSON.stringify(options.data);
        }
      }
    }

    if (!options.contentType) {
      options.contentType = 'application/x-www-form-urlencoded';
    }

    var success = options.success;
    var error = options.error;

    options.success = function (res) {
      _successHandler(res, options, success, error);
    };

    options.error = function (jqXHR) {
      _errorHandler(jqXHR, options, error);
    };

    return $.ajax(
      _.assign({}, options, {
        data: options.type === 'GET' && !options.isKeepData ? {} : options.data,
      }),
    );
  }

  // 请求成功回调方法
  function _successHandler(res, options, success, error) {
    res = _.isString(res) ? JSON.parse(res) : res;

    if (_.has(res, 'code')) {
      // nickname_flag是昵称改动标识
      // pic_flag是头像改动标识
      // 0 完全开放 1 禁止修改 2 验证手机号码 3 人工审核
      if (res.code == 1 || (res.nickname_flag < 1 && res.pic_flag < 1)) {
        //(res.nickname_flag <= 1 && res.pic_flag <= 1)
        res.params = options.data;
        res.options = options;

        MM.core.debug('req:success', options.url, '\n', res);
        success && success(res);
      } else {
        MM.core.debug('req:error', options.url, '\n', res);

        // 认证失败
        if (res.code === 401) {
          MM.log.send({
            event: 'user',
            event_type: 'token_expired',
            content: options,
          });
        }

        if (options.disableCommonErrorHandler) {
          error && error(res);
        } else {
          MM.errors.handleError(res, options.urlType, error);
        }
      }
    } else {
      MM.core.debug('req:success', options.url, '\n', {
        data: res,
        params: options.data,
      });
      success && success({ data: res, params: options.data });
    }
  }

  // 请求失败回调方法
  function _errorHandler(jqXHR, options, callback) {
    var errData = {};
    try {
      errData = JSON.parse(jqXHR.responseText || '{}');
      errData.options = options;
    } catch (e) {
      MM.core.debug('parse data error : ', errData, e);
      MM.log.send({
        event: 'user',
        event_type: 'req_handle_error',
        content: {
          options: options,
          responseText: jqXHR.responseText,
          e: e,
        },
      });
    }

    if (options.disableCommonErrorHandler) {
      callback && callback(errData);
    } else {
      MM.errors.handleError(errData, options.urlType, callback);
    }
  }

  function _getParams(args) {
    var arg_1 = args[0];
    var arg_2 = args[1];
    var arg_3 = args[2];
    var arg_4 = args[3];
    var arg_5 = args[4];

    switch (true) {
      case _.isObject(arg_1):
        return arg_1;
      case _.isFunction(arg_2):
        return {
          url: arg_1,
          success: arg_2,
          error: arg_3,
        };
      case _.isObject(arg_2):
        return {
          url: arg_1,
          data: arg_2,
          success: arg_3,
          error: arg_4,
        };
      default:
        return {
          url: arg_1,
          urlType: arg_2,
          data: arg_3,
          success: arg_4,
          error: arg_5,
        };
    }
  }

  /**
   * [_get description]
   * @param       {String} url     url地址，如果传入的是一个object对象则认为是option
   * @param       {String} type    url type
   * @param       {Object} data    发送的数据
   * @param       {Function} success 请求正确回调
   * @param       {Function} error   请求失败回调
   * @constructor
   * @return      {Object}         一个jqXHR对象
   *
   * 允许的传参格式如下
   * get({ url : xxxx, data : {} }) //第一个参数被判定为option
   * get(url, type, data, success, error)
   * get(url, data, success, error)
   * get(url, success, error)
   */
  function _get() {
    var params = _.assign(_getParams(arguments), { type: 'get' });

    return _request(params);
  }

  /**
   * 使用方法参考get
   * @constructor
   * @return      {[type]} [description]
   */
  function _post() {
    var params = _.assign(_getParams(arguments), { type: 'post' });

    return _request(params);
  }

  function _put() {
    var params = _.assign(_getParams(arguments), { type: 'put' });

    return _request(params);
  }

  function _delete() {
    var params = _.assign(_getParams(arguments), { type: 'delete' });

    return _request(params);
  }

  return {
    send: _request,
    get: _get,
    post: _post,
    put: _put,
    del: _delete,
  };
});
